export default [
  {
    id: 1,
    title: { it: "Sistema Uniko", en: "Uniko system" },
    products: [
      {
        sourceImage: require("./images/mainImgs/home/01b.jpg"),
        detailImage: "UnikoHome",
        room: "Home",
        code: "01b",
        name: { it: "Ingresso", en: "Entrance" },
      },
      {
        sourceImage: require("./images/mainImgs/home/04c.jpg"),

        detailImage: "UnikoHome",
        room: "Home",
        code: "04c",
        name: { it: "Soggiorno", en: "Living room" },
      },
      {
        sourceImage: require("./images/mainImgs/home/10a.jpg"),

        detailImage: "UnikoHome",
        room: "Home",
        code: "10a",
        name: { it: "Camera", en: "Bedroom" },
      },
      {
        sourceImage: require("./images/mainImgs/home/13b.jpg"),

        detailImage: "UnikoHome",
        room: "Home",
        code: "13b",
        name: { it: "Lavanderia", en: "Laundry" },
      },
      {
        sourceImage: require("./images/mainImgs/public/01c.jpg"),

        detailImage: "UnikoPublic",
        room: "Public",
        code: "01c",
        name: { it: "Direzionale", en: "Executive space" },
      },
      {
        sourceImage: require("./images/mainImgs/public/07c.jpg"),

        detailImage: "UnikoPublic",
        room: "Public",
        code: "07c",
        name: { it: "Spazi comuni", en: "Common areas" },
      },
      {
        sourceImage: require("./images/mainImgs/public/14b.jpg"),

        detailImage: "UnikoPublic",
        room: "Public",
        code: "14b",
        name: { it: "Reception", en: "Reception area" },
      },
      {
        sourceImage: require("./images/mainImgs/public/15b.jpg"),

        detailImage: "UnikoPublic",
        room: "Public",
        code: "15b",
        name: { it: "Negozio", en: "Store" },
      },
    ],
  },
];
